import { useEffect, useState } from "react";

import Client from "../client/Client";
import PropTypes from "prop-types";
import getEmployeeKey from "./utils/getEmployeeKey";
import { Wrapper, NoProjectsWrapper } from "./EmployeeDetail.styles";

const EmployeeDetail = ({ details, employee }) => {
    const [clients, setClients] = useState([])

    useEffect(() => {
        let clis = [];
        if (details != null){
            let flags = [], l = details.length, i;
            for(i=0; i < l; i++) {
                if(flags[details[i].clientId]) continue;
                flags[details[i].clientId] = true;
                const cli = {client: details[i].client, clientId: details[i].clientId, allocatedHours: 0};
                clis.push(cli);
            }
        }

        for(const cli of clis){
            let allocatedHoursByClient = 0;
            const projClis = details.filter(d => d.clientId === cli.clientId);
            if (projClis) {
                projClis.forEach((projCli) => {
                    if (projCli.weeks){
                        projCli.weeks.forEach((week) => {
                            allocatedHoursByClient += Math.max(week.allocatedHours, 0);
                        })
                    }
                });
            }
            cli.allocatedHours = allocatedHoursByClient;
        }

        setClients(clis);
    }, [details])

    return (
        <>
            {
                details && clients ? 
                (
                    <Wrapper id={"div_detail_" + getEmployeeKey(employee)}>
                        {clients.map((item, index) => {
                                return (
                                    <Client
                                        client={item.client}
                                        clientId={item.clientId}
                                        key={employee.userId + "_" + item.clientId}
                                        data={details.filter((x) => x.client === item.client)}
                                        employee={employee}
                                        index={index}
                                        opened={item.allocatedHours > 0 || item.clientId <= 0}
                                    />
                                )
                            })}
                    </Wrapper>
                ) : 
                <NoProjectsWrapper>
                    No Projects
                </NoProjectsWrapper>
            }
        </>
    );
};

EmployeeDetail.propTypes = {
    details: PropTypes.array,
    employee: PropTypes.object.isRequired,
};

export default EmployeeDetail;
